import BaseAPI from './BaseAPI';

// Square payment mirror (`payments` + `orders` tables), under /payments.
class PaymentsAPI extends BaseAPI {
  constructor() {
    super('payments');
  }

  // GET /payments?start=&end= → { payments: [...] } (enriched transactions)
  list(start, end) {
    return this.get(`/?start=${start}&end=${end}`);
  }

  // POST /payments/sync?date= → { count } (refetches payments + orders from Square)
  sync(date) {
    return this.post(`/sync${date ? `?date=${date}` : ''}`);
  }

  // GET /payments/customer-appointments?customerId= → { appointments: [...] }
  customerAppointments(customerId) {
    return this.get(`/customer-appointments?customerId=${encodeURIComponent(customerId)}`);
  }

  // PUT /payments/orders/:orderId/appointment { bookId } — link/unlink (admin)
  setAppointment(orderId, bookId) {
    return this.put(`/orders/${encodeURIComponent(orderId)}/appointment`, { body: { bookId } });
  }
}

export const PaymentsService = new PaymentsAPI();
export default PaymentsAPI;
